export default "__VITE_ASSET__b715c51d__"